"use client";

import { createContext } from "react";

import type { ThemeName } from "../theme/types";

export type ThemeContextState = {
  theme: ThemeName;
  themeClasses: Partial<Record<ThemeName, string>>;
};

export const ThemeContext = createContext<ThemeContextState | undefined>(
  undefined,
);
